module.exports = __webpack_public_path__ + "img/banner3_sound.161fd203.png";